import "ol/ol.css";
import GPX from "ol/format/GPX";
import { GeoJSON } from "ol/format";
import Map from "ol/Map";
import VectorSource from "ol/source/Vector";
import View from "ol/View";
import XYZ from "ol/source/XYZ";
import { Circle as CircleStyle, Fill, Stroke, Style } from "ol/style";
import { Tile as TileLayer, Vector as VectorLayer } from "ol/layer";
import { toLonLat } from "ol/proj";
import { fromLonLat } from "ol/proj";
import { toStringHDMS } from "ol/coordinate";
import Overlay from "ol/Overlay";
import Chart from "chart.js";
import "chartjs-plugin-zoom/chartjs-plugin-zoom";
import "@fortawesome/fontawesome-free/js/all";

if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register(new URL('service-worker.js', import.meta.url))
      .then(function(reg){
        console.log("Service worker registered.");
     }).catch(function(err) {
        console.log("Service worker failed to register:", err)
    });
 }

function getColorForBatteryPercentage(p) {
	var red = p < 50 ? 255 : Math.round(256 - (p - 50) * 5.12);
	var green = p > 50 ? 255 : Math.round(p * 5.12);
	return "rgb(" + red + "," + green + ",0)";
}

function updateShipmentList(showAll = false) {
	$.ajax({
		dataType: "json",
		url:
			"https://covacc.co.uk/api/list_shipments.php" +
            (showAll ? "" : "?l=5"),
        xhrFields: { withCredentials: true },
		success: function (shipments) {
			var html = "";
			// $("#shipment-entries").html("");
			shipments.forEach((shipment) => {
				var shipmentId = shipment["id"];
				var shipmentName = shipment["name"];
				var batteryPer = shipment["batt"];
				let batteryIcon = `<span class="dot" style="background-color: ${getColorForBatteryPercentage(
					batteryPer
				)}">`;
				if (batteryPer === null) {
					batteryPer = `<div class="complete">
					<p>Completed</p> `;
					batteryIcon = `<svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg>`;
				} else batteryPer += "%";

				html += `<a href="javascript:loadData(${shipmentId})">
                      <div class="list-row">
                          <div class="shipment-name">${shipmentName}</div>
                              <div class="battery">
                                  </span> ${batteryPer}
                                  ${batteryIcon}  </span> 
                              </div>
                          </div>
                      </div>
                  </a>`;
			});
			$("#shipment-entries").html(html);
        },
        statusCode: {
            401: function() {
                location.reload();
            }
        }
	});
}

// Show the latest shipment entries in the list
$(document).ready(function () {
    if (isLoggedIn)
	    updateShipmentList(false);
});

let updateAllShipments = false;

// Show all the shipment entries in the list
$("#list-topics").on("click", function () {
	updateShipmentList(true);
	updateAllShipments = true;
	$("#list-topics").hide();
});

// setInterval(function () {
// 	updateShipmentList(updateAllShipments);
// }, 300000);

window.onload = function() {
    var reloading = sessionStorage.getItem("reloading");
    if (reloading) {
        sessionStorage.removeItem("reloading");
        updateAllShipmentList(updateAllShipments);
    }
}

function reloadP() {
    sessionStorage.setItem("reloading", "true");
    document.location.reload();
}

window.popUpContact = function popUpContact() {
	document.getElementById("contact-form-popup").style.display = "grid";
	setTimeout(function () {
		document.getElementById("contact-form-popup").style.opacity = "1";
	}, 10);
};

window.closePopUp = function closePopUp() {
	document.getElementById("contact-form-popup").style.opacity = "0";
	setTimeout(function () {
		document.getElementById("contact-form-popup").style.display = "none";
	}, 400);
};

window.menuOnClick = function menuOnClick() {
	document.getElementById("menu-bar").classList.toggle("change");
	document.getElementById("nav").classList.toggle("change");
	document.getElementById("menu-bg").classList.toggle("change-bg");
};

var isLoggedIn = false;
$(document).ready(function () {
	updateLoginButton();

	const loginWrapper = document.getElementById("loginwrapper");
	const loginForm = document.getElementById("login-form");
	const loginButton = document.getElementById("login-form-submit");
	const loginErrorMsg = document.getElementById("login-error-msg");

	window.showLogin = function showLogin() {
		if (isLoggedIn) {
			isLoggedIn = false;
			let settings = {
				url: "https://covacc.co.uk/api/logout",
				method: "POST",
				timeout: 0,
				headers: {
					"Content-Type": "text/plain",
				},
                dataType: "json",
                xhrFields: { withCredentials: true }
			};
			$.ajax(settings)
				.done(function (response) {
					if (response.message === "Logout successful") {
						isLoggedIn = false;
						toggleLoggedState();
					} else {
						alert("Something went wrong when trying to log out");
					}
				})
				.fail(function () {
					loginErrorMsg.style.opacity = 1;
				});
			toggleLoggedState();
			return;
		}
		loginWrapper.style.display = "grid";
	};

	function updateLoginButton() {
		if (isLoggedIn) {
			document.getElementById("logged-in-state").innerHTML =
				"&#xf007; Log Out";
		} else {
			document.getElementById("logged-in-state").innerHTML =
				"&#xf090 Log In";
		}
	}

	function toggleLoggedState() {
		updateLoginButton();
		if (!isLoggedIn) {
			document.getElementById("display-data-button").style.display =
				"none";
			document.getElementById("display-data-button-hmenu").style.display =
				"none";
			document.getElementById("Check-Condition").style.display = "block";
			document.getElementById("shipments").style.display = "none";
		} else {
			document.getElementById("display-data-button").style.display =
				"inline-block";
			document.getElementById("display-data-button-hmenu").style.display =
				"inline-block";
			document.getElementById("Check-Condition").style.display = "none";
			document.getElementById("shipments").style.display = "grid";
		}
	}

	loginButton.addEventListener("click", (e) => {
		e.preventDefault();
		const username = loginForm.username.value;
		const password = loginForm.password.value;
		var isCorrect;
		let settings = {
			url: "https://covacc.co.uk/api/login",
			method: "POST",
			timeout: 0,
			headers: {
				"Content-Type": "text/plain",
			},
			data: `{\n  \"username\": \"${username}\",\n  \"password\": \"${password}\"\n}`,
            dataType: "json",
            xhrFields: { withCredentials: true }
		};
		$.ajax(settings)
			.done(function (response) {
				isCorrect = response.success;
				if (isCorrect) {
					loginSuccess();
				} else {
					loginErrorMsg.style.opacity = 1;
				}
			})
			.fail(function () {
				loginErrorMsg.style.opacity = 1;
			});
	});

	function loginSuccess() {
		isLoggedIn = true;
		updateLoginButton();
		loginWrapper.style.display = "none";
        toggleLoggedState();
        updateShipmentList(false);
    }
    
    let settings = {
		url: "https://covacc.co.uk/api/login",
		method: "GET",
		timeout: 0,
		headers: {
			"Content-Type": "text/plain",
		},
        dataType: "json",
        xhrFields: { withCredentials: true }
	};
	$.ajax(settings).done(function (response) {
        if (response.logged_in)
        {
            loginSuccess();
        }
		toggleLoggedState();
	});
});

window.chartColors = {
	red: "#af1414",
	orange: "rgb(255, 159, 64)",
	yellow: "rgb(255, 205, 86)",
	green: "rgb(75, 192, 192)",
	blue: "rgb(54, 162, 235)",
	purple: "rgb(153, 102, 255)",
	maincolor: "#af1414",
	grey: "rgb(201, 203, 207)",
};

function checkIsMobile() {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
};
window.isMobile = checkIsMobile();

var ctx = document.getElementById("chart").getContext("2d");
var chartConfig = {
	type: "line",
	data: {
		labels: [],
		datasets: [
			{
				label: [],
				pointBackgroundColor: [],
				backgroundColor: window.chartColors.maincolor,
				borderColor: window.chartColors.blue,
				data: [],
                fill: false,                
                hitRadius: window.isMobile ? 20 : 1,
                // pointHoverRadius: 3,
                // hoverBorderWidth: 0.5,
                // hoverBackgroundColor: 
			},
		],
	},

	options: {
		responsive: true,
		// maintainAspectRatio: false,
		aspectRatio: 2,
		animation: {
			duration: 0, // general animation time
		},
		hover: {
            // intersect: true,
            animationDuration: 0, // duration of animations when hovering an item
		},
		responsiveAnimationDuration: 0, // animation duration after a resize
		legend: {
			display: false,
		},
		tooltips: {
            mode: "nearest",
            // axis: 'x',
            position: "nearest",
			callbacks: {
				label: function (tooltipItem) {
                    tooltipItem.getPix
					return tooltipItem.yLabel;
				},
			},
		},
		// layout: {
		// 	padding: {
		// 		left: -30,
		// 	},
		// },
		elements: {
		    line: {
                tension: 0, // disables bezier curves
                borderJoinStyle: "round",
		    }
		},
		// showLines: false,
		scales: {
			yAxes: [
				{
					// scaleLabel: {
					// 	display: true,
					// 	labelString: "Temperature (Celcius)",
					// 	fontSize: 15,
					// 	fontColor: window.chartColors.maincolor,
					// },
					ticks: {
						fontSize: 15,
						//suggestedMin: -70.5,
						//suggestedMax: -69.3,
						beginAtZero: false,
						fontColor: "#000000",
					},
				},
			],

			xAxes: [
				{
					type: "time",
					time: {
						// unit: "hour",
						// format: "HH:mm",
						unitStepSize: 1,
						displayFormats: {
							minute: "HH:mm",
							hour: "HH:mm",
							// min: '00:00',
							// max: '23:59'
						},
					},
					// scaleLabel: {
					// 	fontSize: 15,
					// 	fontColor: window.chartColors.maincolor,
					// 	display: true,
					// 	labelString: "Time (hour / minute) ",
					// },
					ticks: {
						fontColor: "#000000",
						fontSize: 12,
						beginAtZero: false,
						maxTicksLimit: 10,
						// maxRotation: 0,
						// minRotation: 0,
						sampleSize: 1,
					},
					gridLines: {
						zeroLineWidth: 0.5,
					},
					afterFit: (axis) => {
						axis.paddingRight = 0;
						axis.padding = 0;
					},
				},
			],
		},
		plugins: {
			zoom: {
				pan: {
					enabled: true,
					mode: "x", // is panning about the y axis neccessary for bar charts?
				},
				zoom: {
					enabled: true,
					mode: "x",
					sensitivity: 5,
					speed: 0.2,
				},
			},
		},
	},
};
var chart = new Chart(ctx, chartConfig);

let PreviousNumberOfSamples = 0;
let ShipmentToUpdate = undefined;
function updateChart() {
	if (ShipmentToUpdate == undefined) return;
	$.ajax({
		dataType: "json",
        url: "https://covacc.co.uk/api/shipment_data.php?s=" + ShipmentToUpdate,
        xhrFields: { withCredentials: true },
		success: function (data) {
			if (data.length == PreviousNumberOfSamples) return;
			PreviousNumberOfSamples = data.length;

			document.getElementById("chartcontainer").style.display = "grid";
			document.getElementById("mapcontainer").style.display = "grid";

            var dataset = chart.data.datasets[0];

			// Clear old data:
			chart.data.labels = [];
			dataset.data = [];
			dataset.label = [];

			var pointBackgroundColors = [];
			dataset.data = [];
			data.forEach((d) => {
				dataset.data.push(d["temperature"]);
				chart.data.labels.push(new Date(d["timestamp"] * 1000));
				if (d["shock"] >= 1) {
					pointBackgroundColors.push(window.chartColors.maincolor);
				} else {
					pointBackgroundColors.push(window.chartColors.grey);
				}
			});
			dataset.pointBackgroundColor = pointBackgroundColors;

			chart.update();
        },
        statusCode: {
            401: function() {
                location.reload();
            }
        }
	});
}

setInterval(updateChart, 5000);

window.loadData = function loadData(ShipmentIndex) {
	ShipmentToUpdate = ShipmentIndex;
	$.ajax({
		dataType: "json",
        url: "https://covacc.co.uk/api/shipment_data.php?s=" + ShipmentIndex,
        xhrFields: { withCredentials: true },
		success: function (data) {
			document.getElementById("chartcontainer").style.display = "grid";
			document.getElementById("mapcontainer").style.display = "grid";
			

            var dataset = chart.data.datasets[0];

			// Clear old data:
			chart.data.labels = [];
			dataset.data = [];
			dataset.label = [];

			var pointBackgroundColors = [];
			dataset.data = [];
			data.forEach((d) => {
				dataset.data.push(d["temperature"]);
				chart.data.labels.push(new Date(d["timestamp"] * 1000));
				if (d["shock"] >= 1) {
					pointBackgroundColors.push(window.chartColors.maincolor);
				} else {
					pointBackgroundColors.push(window.chartColors.grey);
				}
			});
			dataset.pointBackgroundColor = pointBackgroundColors;

			chart.update();
			chart.resetZoom();

			////////MAP

			document.getElementById("mapcontainer").innerHTML = `
            <div class="section">
				<div class="mapinfo">
				<h2>Route of the journey</h2>
                    <p style="text-align: justify;">The map shows the route of the journey. Each point shows the measured latitude and longitude of the shipment. For more information, please hover over/tap on the points.</p>
                    <div id="map" class="map"></div>
                    <div id="info">&nbsp;</div>
                    <div id="popup" class="ol-popup">
                        <a href="#" id="popup-closer" class="ol-popup-closer"></a>
                        <div id="popup-content"></div>
                    </div>
                </div>
            </div>`;

			document.getElementById("map").innerHTML = "";

			var epsgCoords = [];
			data.forEach((d) => {
				epsgCoords.push(fromLonLat([d["longitude"], d["latitude"]]));
			});

			var geojsonObject = {
				type: "FeatureCollection",
				crs: {
					type: "name",
					properties: {
						name: "EPSG:3857",
					},
				},
				features: [
					{
						type: "Feature",
						geometry: {
							type: "LineString",
							coordinates: epsgCoords,
						},
					},
				],
			};
			data.forEach((d) => {
				geojsonObject.features.push({
					type: "Feature",
					geometry: {
						type: "Point",
						coordinates: fromLonLat([
							d["longitude"],
							d["latitude"],
						]),
					},
					properties: {
                        time: d["timestamp"],
                        shock: d["shock"] > 0,
					},
				});
			});

			//Elements that make up the popup.
			var container = document.getElementById("popup");
			var content = document.getElementById("popup-content");
			var closer = document.getElementById("popup-closer");

			//Create an overlay to anchor the popup to the map.
			var overlay = new Overlay({
				element: container,
				autoPan: true,
				autoPanAnimation: {
					duration: 250,
				},
			});

			// Add a click handler to hide the popup. @return {boolean} Don't follow the href.
			closer.onclick = function () {
				overlay.setPosition(undefined);
				closer.blur();
				return false;
			};

			var attributions =
				'<a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>';

			var raster = new TileLayer({
				source: new XYZ({
					attributions: attributions,
					url: "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
					maxZoom: 20,
				}),
			});


            let PointShockStyle = new Style({
                image: new CircleStyle({
                    fill: new Fill({
                        color: window.chartColors.red,
                    }),
                    radius: 5,
                    stroke: new Stroke({
                        color: window.chartColors.blue,
                        width: 1,
                    }),
                }),
            });
            let PointNoShockStyle = new Style({
                image: new CircleStyle({
                    fill: new Fill({
                        color: window.chartColors.grey,
                    }),
                    radius: 5,
                    stroke: new Stroke({
                        color: window.chartColors.blue,
                        width: 1,
                    }),
                }),
            });
			var style = {
				LineString: new Style({
					stroke: new Stroke({
						color: "#3e90ce",
						width: 3,
					}),
				}),
				MultiLineString: new Style({
					stroke: new Stroke({
						color: "#ffffff",
						width: 3,
					}),
				}),
			};

			var vector = new VectorLayer({
				source: new VectorSource({
					features: new GeoJSON().readFeatures(geojsonObject),
				}),
				renderBuffer: 100000000, // To fix the issue of lines disappearing when partially off screen
				style: function (feature) {
                    if (feature.getGeometry().getType() == "Point")
                    {
                        if (feature.values_.shock)
                            return PointShockStyle;
                        return PointNoShockStyle;
                    }
					return style[feature.getGeometry().getType()];
				},
			});

			var map = new Map({
				layers: [raster, vector],
				overlays: [overlay],
				target: document.getElementById("map"),
				view: new View({
					zoom: 10,
					maxZoom: 19,
				}),
			});

			var extent = vector.getSource().getExtent();
			map.getView().fit(extent, { padding: [50, 50, 50, 50] });

			var displayFeatureInfo = function (pixel) {
				var features = [];
				map.forEachFeatureAtPixel(pixel, function (feature) {
					features.push(feature);
				}, {hitTolerance: window.isMobile ? 5 : 0});
				if (features.length > 0) {
					var info = [];
					var i, ii;
					for (i = 0, ii = features.length; i < ii; ++i) {
						// isPoint = features[i].values_.geometry.constructor.name === "Point"; // This doesn't work after Parcel minifies the code because the 'Point' class changes its name
						let isPoint =
							features[i].values_.geometry.flatCoordinates
								.length === 2; // This is a slightly dodgy workaround

						var timestamp = new Date(0); // The 0 there is the key, which sets the date to the epoch
						timestamp.setUTCSeconds(features[i].values_.time);

						if (isPoint) {
							let pointCoordinate =
								features[i].values_.geometry.flatCoordinates;
							let lonString = `Lon: ${toLonLat(
								pointCoordinate
							)[0].toFixed(3)}`;
							let latString = `Lat: ${toLonLat(
								pointCoordinate
							)[1].toFixed(3)}`;
							map.getTarget().style.cursor = "pointer";
							info.push(toLonLat(pointCoordinate));
							content.innerHTML = `<p>Coordinates: </p><code>${lonString} ${latString}</code><br>
							<p>Date and time: </p> <code>${timestamp.toLocaleString()}</code>`;
							overlay.setPosition(pointCoordinate);
						} else {
							map.getTarget().style.cursor = "";
						}
					}
				} else closer.onclick();
			};

			map.on("pointermove", function (evt) {
				if (evt.dragging) {
					return;
				}
				var pixel = map.getEventPixel(evt.originalEvent);
				displayFeatureInfo(pixel);
            });
            
            // setTimeout(function () {document.querySelector('#chartcontainer').scrollIntoView({behavior: 'smooth'})}, 0);
		},
	});
};
